<template>
  <div class="bg-container page">
    <img class="bg-img" src="/img/login-bg.png" alt="" />
    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#d7d7d7" size="22" @click="back" />
          </template>
        </van-nav-bar>

        <div class="wrapper">
          <div class="logo-container">
            <div class="logo-wrapper">
              <img class="logo-img" src="/img/app-logo.png" alt="logo" />
            </div>
          </div>

          <div class="loginForm">
            <van-field
              v-model="username"
              class="input"
              clearable
              :placeholder="$t('auth.username_place')"
            />
            <van-field
              v-model="password"
              class="input"
              :type="passwordType"
              :placeholder="$t('auth.pwd_place')"
            >
              <template #right-icon>
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  color="#ff7186"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            <van-field
              v-model="confirmPassword"
              class="input"
              :type="confirmPasswordType"
              :placeholder="$t('auth.confirm_pwd_place')"
            >
              <template #right-icon>
                <van-icon
                  :name="confirmPasswordType === 'password' ? 'closed-eye' : 'eye-o'"
                  color="#ff7186"
                  @click="switchConfirmPasswordType"
                />
              </template>
            </van-field>
            <van-field
              v-model="inviteCode"
              class="input"
              clearable
              :placeholder="$t('auth.invite_code_place')"
            />

            <div class="agreement">
              <van-checkbox v-model="agreed" icon-size="18px" checked-color="#ff7186" />
              <span class="agreement-text">{{ $t("auth.agreement_place") }}</span>
            </div>

            <van-button
              class="login-btn"
              :class="{ active: canSubmit }"
              type="primary"
              :loading="registering"
              :disabled="registering"
              @click="doRegister()"
            >
              {{ registering ? $t("auth.registering") : $t("auth.register") }}
            </van-button>

            <div class="register-text" @click="back">
              <span>{{ $t("auth.has_account") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/http/index";
import { getStoredLang } from "@/utils/lang";

export default {
  name: "RegisterPage",
  data() {
    return {
      username: "",
      password: "",
      confirmPassword: "",
      inviteCode: "",
      agreed: true,
      passwordType: "password",
      confirmPasswordType: "password",
      registering: false,
      lang: getStoredLang(),
    };
  },
  computed: {
    canSubmit() {
      return (
        this.username.trim() &&
        this.password.trim() &&
        this.confirmPassword.trim() &&
        this.inviteCode.trim() &&
        this.agreed
      );
    },
  },
  mounted() {
    this.lang = getStoredLang();
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    switchConfirmPasswordType() {
      this.confirmPasswordType =
        this.confirmPasswordType === "password" ? "text" : "password";
    },
    back() {
      this.$router.push("/Login");
    },
    validateForm() {
      if (!this.username.trim()) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (this.username.length < 6 || this.username.length > 20) {
        this.$toast.fail(this.$t("auth.username_rule"));
        return false;
      }
      if (!this.password.trim()) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if (this.password.length < 6 || this.password.length > 16) {
        this.$toast.fail(this.$t("auth.password_rule"));
        return false;
      }
      if (this.password !== this.confirmPassword) {
        this.$toast.fail(this.$t("auth.password_mismatch"));
        return false;
      }
      if (!this.inviteCode.trim()) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if (!this.agreed) {
        this.$toast.fail(this.$t("auth.please_agree_terms"));
        return false;
      }
      return true;
    },
    async doRegister() {
      if (!this.validateForm()) return;
      try {
        this.registering = true;
        const result = await http({
          method: "post",
          url: "member_register",
          data: {
            username: this.username.trim(),
            password: this.password.trim(),
            code: this.inviteCode.trim(),
            lang: this.lang,
          },
        });

        if (result && result.code === 200) {
          this.$toast.success(this.$t("auth.register_success"));
          if (result.data) {
            localStorage.setItem("token", result.data);
          }
          setTimeout(() => {
            this.$router.replace("/Home");
          }, 800);
        } else {
          let errorMsg = result.msg || this.$t("auth.register_failed");
          if (result.code === 401) {
            if (
              errorMsg.includes("用户名已存在") ||
              errorMsg.includes("Username already exists")
            ) {
              errorMsg = this.$t("auth.username_exists");
            } else if (
              errorMsg.includes("邀请码无效") ||
              errorMsg.includes("Invalid invitation code")
            ) {
              errorMsg = this.$t("auth.invalid_invite_code");
            }
          }
          this.$toast.fail(errorMsg);
        }
      } catch (error) {
        console.error("注册出错:", error);
        this.$toast.fail(this.$t("auth.register_failed") + error.message);
      } finally {
        this.registering = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bg-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: #fff;
  overflow: hidden;
}

.bg-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.bg-wrapper {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 113, 134));
}

.register {
  position: relative;
  height: 100%;
  overflow: hidden;
  background: transparent;
}

.nav-bar {
  background: transparent !important;

  /deep/ .van-nav-bar,
  /deep/ .van-nav-bar__content {
    background: transparent !important;
  }

  /deep/ .van-hairline--bottom::after {
    border: none !important;
  }
}

.wrapper {
  height: calc(100% - 46px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.logo-container {
  margin: 0 auto;
  width: 45%;
}

.logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}

.logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0.8;
}

.loginForm {
  padding: 8vw;
}

/deep/ .input {
  padding: 1.333vw 2.667vw !important;
  margin-top: 5.333vw;
  border-radius: 6.667vw !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  border: none !important;
  color: #ff7186;

  .van-field__control {
    color: #fff !important;
    font-size: 3.2vw;
    text-align: center;
    height: 10.667vw;
    line-height: 10.667vw;

    &::placeholder {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .van-field__right-icon .van-icon {
    font-size: 6.667vw !important;
    color: #ff7186 !important;
  }
}

/deep/ .van-cell::after {
  display: none;
}

.agreement {
  margin: 5.333vw 0 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
}

.agreement-text {
  color: #fff;
  font-size: 3.2vw;
  line-height: 1.5;
  text-align: left;
}

.login-btn {
  margin-top: 11.333vw;
  width: 100%;
  height: 13.333vw;
  border: none !important;
  border-radius: 6.667vw !important;
  font-size: 3.2vw;
  font-weight: 700;
  background: #cacacc !important;
  color: #fff !important;

  &.active {
    background: linear-gradient(90deg, #ff8395, #ff556e) !important;
  }
}

.register-text {
  margin-top: 5.333vw;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  span {
    color: #fff;
    font-size: 3.333vw;
    font-weight: 500;
  }
}
</style>
